var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * A request-only (managed) space is mutually exclusive with all other
 * spaces — an event holds either exactly one request-only space or any
 * number of scheduled ones. The incoming space wins: adding a request-only
 * space replaces the whole list, and adding a scheduled space drops any
 * request-only space already selected.
 *
 * Every path that appends a space to `form.spaces` must resolve through
 * this rule so no emitter (sider, search, cross-app patches) can mix them.
 */
export function resolveSpacesAfterAdd(currentSpaces, incomingSpace) {
    if (incomingSpace.isManaged) {
        return [incomingSpace];
    }
    return __spreadArray(__spreadArray([], __read(currentSpaces.filter(function (space) { return !space.isManaged; })), false), [incomingSpace], false);
}
